import React, { Suspense, lazy } from 'react';
import { HeroSection } from '../components/sections/HeroSection';
// Everything below hero is lazy-loaded
const ProblemSection = lazy(() => import('../components/sections/ProblemSection').then(m => ({
  default: m.ProblemSection
})));
const SolutionSection = lazy(() => import('../components/sections/SolutionSection').then(m => ({
  default: m.SolutionSection
})));
const BenefitsSection = lazy(() => import('../components/sections/BenefitsSection').then(m => ({
  default: m.BenefitsSection
})));
const BonusSection = lazy(() => import('../components/sections/BonusSection').then(m => ({
  default: m.BonusSection
})));
const ScarcitySection = lazy(() => import('../components/sections/ScarcitySection').then(m => ({
  default: m.ScarcitySection
})));
const PricingSection = lazy(() => import('../components/sections/PricingSection').then(m => ({
  default: m.PricingSection
})));
const TestimonialSection = lazy(() => import('../components/sections/TestimonialSection').then(m => ({
  default: m.TestimonialSection
})));
const GuaranteeSection = lazy(() => import('../components/sections/GuaranteeSection').then(m => ({
  default: m.GuaranteeSection
})));
const FAQSection = lazy(() => import('../components/sections/FAQSection').then(m => ({
  default: m.FAQSection
})));
const ClosingSection = lazy(() => import('../components/sections/ClosingSection').then(m => ({
  default: m.ClosingSection
})));
const FooterSection = lazy(() => import('../components/sections/FooterSection').then(m => ({
  default: m.FooterSection
})));
const SocialProofPopup = lazy(() => import('../components/ui/SocialProofPopup').then(m => ({
  default: m.SocialProofPopup
})));
export function LandingPage() {
  return <main className="min-h-screen bg-background-dark text-gray-300 font-body selection:bg-primary/30 selection:text-white" data-id="element-462">
      <HeroSection data-id="element-463" />
      <Suspense fallback={null} data-id="element-464">
        <ProblemSection data-id="element-465" />
        <SolutionSection data-id="element-466" />
        <BenefitsSection data-id="element-467" />
        <BonusSection data-id="element-468" />
        <ScarcitySection data-id="element-469" />
        <PricingSection data-id="element-470" />
        <TestimonialSection data-id="element-471" />
        <GuaranteeSection data-id="element-472" />
        <FAQSection data-id="element-473" />
        <ClosingSection data-id="element-474" />
        <FooterSection data-id="element-475" />
        <SocialProofPopup data-id="element-476" />
      </Suspense>
    </main>;
}